import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ChimieService, Chimie } from '../../../services/chimie.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-voir-chimies',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './voir-chimies.component.html',
  styleUrl: './voir-chimies.component.scss'
})
export class VoirChimiesComponent implements OnInit {
  chimies: Chimie[] = [];
  loading = false;
  error = '';
  success = '';

  deletingId: number | null = null;

  constructor(
    private readonly chimieService: ChimieService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadChimies();
  }

  loadChimies(): void {
    this.loading = true;
    this.success = '';
    this.error = '';
    this.chimieService.list().subscribe({
      next: (chimies) => {
        this.chimies = chimies;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.error = 'Erreur lors du chargement des chimies';
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  deleteChimie(id: number): void {
    if (!confirm('Supprimer cette chimie ?')) return;
    this.deletingId = id;
    this.success = '';
    this.error = '';
    this.chimieService.delete(id).subscribe({
      next: () => {
        this.success = 'Chimie supprimée.';
        this.loadChimies();
        this.deletingId = null;
        this.cdr.detectChanges();
      },
      error: () => {
        this.error = 'Erreur lors de la suppression.';
        this.deletingId = null;
        this.cdr.detectChanges();
      }
    });
  }

  editChimie(id: number): void {
    this.router.navigate(['/intranet/gestion-stocks/chimie/modifier'], { queryParams: { id } });
  }
}
